<script>
  import { getContext } from 'svelte';
  import { Button, Checkbox } from 'carbon-components-svelte';

  export let invalid = false,
    nextButtonActive = false,
    previousButtonActive = true,
    onBeforeForward = null,
    onBeforeBack = null,
    onBeforeFinish = null;

  let stepIsReady = false;

  const {
    addContent,
    confirmationBeforeSubmit,
    confirmationMessage,
    currentStep,
    finalStepButtonLabel,
    getContentUpdater,
    goBack,
    goForward,
    onFinish,
    setStep,
    steps,
  } = getContext('wizard');
  const stepIndex = addContent({ nextButtonActive, previousButtonActive, invalid });
  const updateContent = getContentUpdater(stepIndex);

  function handleGoForward() {
    if (onBeforeForward) {
      onBeforeForward(stepIndex);
    }

    goForward();
  }

  function handleGoBack() {
    if (onBeforeBack) {
      onBeforeBack(stepIndex);
    }

    goBack();
  }

  function handleFinish() {
    if (onBeforeFinish) {
      onBeforeFinish(stepIndex);
    }

    onFinish();
  }

  $: {
    // TODO: is there a better way to align store with prop changes?
    updateContent((currentContent) => ({
      ...currentContent,
      nextButtonActive,
      previousButtonActive,
      invalid,
    }));
  }
  $: isCurrentStep = $currentStep === stepIndex;
  $: isLastStep = stepIndex === steps.length - 1; // eslint-disable-line svelte/no-immutable-reactive-statements
  $: stepIsReady = !(isLastStep && confirmationBeforeSubmit);
</script>

{#if isCurrentStep}
  <div class="wizard-step">
    <div class="content">
      <slot {stepIndex} {setStep} />
    </div>
    <div class="footer">
      {#if confirmationBeforeSubmit && isLastStep}
        <div class="confirmation">
          <Checkbox labelText={confirmationMessage ?? 'I verify the input is valid and I want to proceed.'} bind:checked={stepIsReady} />
        </div>
      {/if}
      <slot name="navigation" {goForward} {goBack}>
        <div class="navigation">
          {#if stepIndex !== 0}
            <Button size="field" kind="secondary" disabled={!previousButtonActive} on:click={handleGoBack}>Previous</Button>
          {/if}
          {#if !isLastStep}
            <Button size="field" disabled={!nextButtonActive} on:click={handleGoForward}>Next</Button>
          {:else}
            <Button size="field" disabled={!stepIsReady} on:click={handleFinish}>{finalStepButtonLabel}</Button>
          {/if}
        </div>
      </slot>
    </div>
  </div>
{/if}

<style>
  .content {
    margin: 1rem 0;
  }

  .footer {
    position: sticky;
    bottom: 0;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    background-color: var(--cds-ui-01);
    z-index: 1;
  }

  .navigation {
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: 0.1rem;
  }

  .confirmation,
  .navigation {
    padding-top: 0.25rem;
  }
</style>
